import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/esri.webp';
import screenshot_target from '../../../images/letterfunnel/jeroenvanwinden.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jeroen Van Winden"
      firstname="Jeroen"
      companyname="Esri"
      competition="QGIS en CARTO"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jeroenvanwinden.js